import clsx from 'clsx';
import React, { useState } from 'react';

import Button from '@components/Button';
import CustomSpinner from '@components/Spinner/CustomSpinner';
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { buildQueryString } from '@utils/queryStringHelper';

import styles from './styles.module.scss';

const PaymentMethod = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const protocol = window.location.protocol;
  const host = window.location.host;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      setErrorMessage('Still loading Stripe. Please wait a few seconds and then try again.');
      return;
    }

    setIsLoading(true);

    // Trigger form validation and wallet collection
    const { error: submitError } = await elements.submit();
    if (submitError) {
      setErrorMessage(submitError.message);
      setIsLoading(false);
      return;
    }

    const queryString = buildQueryString({
      update_payment: true,
    });
    const { error } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        // Can't use READER_URL for testing, so this is used to build URLs dynamically
        return_url: `${protocol}//${host}/payment-status?${queryString}`,
      },
      redirect: 'always',
    });

    setIsLoading(false);
    if (error) {
      setErrorMessage(error.message);
      return;
    }
  };

  return (
    <div id="payment-form" className="stripe-payment-form">
      <PaymentElement
        onChange={() => setErrorMessage('')}
        options={{
          layout: {
            type: 'tabs',
            defaultCollapsed: false,
          },
        }}
      />
      {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
      <Button
        onClick={handleSubmit}
        disabled={!stripe || isLoading}
        type="submit"
        className={clsx(styles.submitBtn, 'mt-16')}
      >
        {isLoading ? (
          <CustomSpinner
            color="#fff"
            size={10}
            style={{ display: 'flex', justifyContent: 'center' }}
          />
        ) : (
          <>Update Payment</>
        )}
      </Button>
    </div>
  );
};

export default PaymentMethod;
